module.exports = __webpack_public_path__ + "3-59.jpg?f53c3bfaef3c40b0a0fc9d4a909dd364";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/3-59.jpg
// module id = 141
// module chunks = 0